import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStakeholdersRoute: InvariantJiraRoute = {
	name: 'communications-stakeholders',
	path: '/jira/communications/stakeholders',
};
